/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { NFTRaffleAddressRegistry } from "../NFTRaffleAddressRegistry";

export class NFTRaffleAddressRegistry__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<NFTRaffleAddressRegistry> {
    return super.deploy(overrides || {}) as Promise<NFTRaffleAddressRegistry>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): NFTRaffleAddressRegistry {
    return super.attach(address) as NFTRaffleAddressRegistry;
  }
  connect(signer: Signer): NFTRaffleAddressRegistry__factory {
    return super.connect(signer) as NFTRaffleAddressRegistry__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NFTRaffleAddressRegistry {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as NFTRaffleAddressRegistry;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "basePoolURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collectionRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "controller",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "oracle",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poolFactory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardsDistributor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokenRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_basePoolURI",
        type: "string",
      },
    ],
    name: "updateBasePoolURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_collectionRegistry",
        type: "address",
      },
    ],
    name: "updateCollectionRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_controller",
        type: "address",
      },
    ],
    name: "updateController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_oracle",
        type: "address",
      },
    ],
    name: "updateOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_poolFactory",
        type: "address",
      },
    ],
    name: "updatePoolFactory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_rewardsDistributor",
        type: "address",
      },
    ],
    name: "updateRewardsDistributor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenRegistry",
        type: "address",
      },
    ],
    name: "updateTokenRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wEVMOS",
        type: "address",
      },
    ],
    name: "updateWEVMOS",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "wEVMOS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
